import { useEffect, useState } from "react";
import { notificationService } from "@/services/api";

// Same pattern as useNewAlertsCount — the bell icon's dot used to be
// unconditional (`<span className="... bg-primary ...">`), showing
// regardless of whether anything was actually unread.
export function useUnreadNotificationsCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      notificationService
        .unreadCount()
        .then((n) => { if (!cancelled) setCount(n); })
        .catch(() => {});
    };
    load();
    const interval = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  return count;
}
